import { checkSearchObject } from "app/common/LocalFunction";
import { DrugRoute } from "app/common/Model/DrugRoute";
import { SearchObject } from "app/common/Model/SearchObject";
import {
  deleteDrugRoute,
  getDrugRouteById,
  pagingDrugRoute,
  saveDrugRouteSyncStore,
  saveOrUpdateDrugRoute,
} from "app/services/DrugRouteService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class DrugRouteStore {
  listAllDrugRoute = [];
  searchDrugRoute = new SearchObject();
  pageDrugRoute = null;
  selectedDrugRoute = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteDrugRoute = false;
  recentlyUpdated = false;
  openSyncStore = false

  constructor() {
    makeAutoObservable(this);
  }

  getAllDrugRoute = () => {
    if (!this.listAllDrugRoute?.length || this.recentlyUpdated) {
      return pagingDrugRoute({
        pageIndex: 1,
        pageSize: 1000000,
      })
        .then(({ data }) => {
          this.listAllDrugRoute = data?.content;
          this.recentlyUpdated = false;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    }
  }

  pagingDrugRouteMethod = () => {
    pagingDrugRoute(this.searchDrugRoute).then(({ data }) => {
      this.pageDrugRoute = data;
    });
  };

  handleChangeSearchForm = (searchDrugRoute) => {
    this.searchDrugRoute = checkSearchObject(
      this.searchDrugRoute,
      searchDrugRoute
    );
    this.pagingDrugRouteMethod();
  };

  handleOpenFormCreateOrEdit = async (drugRouteId) => {
    if (Boolean(drugRouteId)) {
      try {
        const { data } = await getDrugRouteById(drugRouteId);
        if (data) {
          this.selectedDrugRoute = data;
          this.openFormCreateOrEdit = true;
        }
      } catch {
        toast.error("Lấy dữ liệu có lỗi!");
      }
    } else {
      this.selectedDrugRoute = new DrugRoute();
      this.openFormCreateOrEdit = true;
    }
  };

  saveDrugRouteMethod = async (drugRoute, { setSubmitting }) => {
    try {
      const { data } = await saveOrUpdateDrugRoute(drugRoute);
      if (data) {
        this.selectedDrugRoute = null;
        this.pagingDrugRouteMethod();
        this.handleClosePopup();
        this.recentlyUpdated = true;

        toast.success("Lưu đường dùng của thuốc thành công!");
      }
    } catch {
      toast.error("Lưu đường dùng của thuốc thất bại!");
    } finally {
      setSubmitting(false);
    }
  };

  handleConfirmDeleteDrugRoute = async () => {
    try {
      await deleteDrugRoute(this.selectedDrugRoute?.id);
      if (
        this.searchDrugRoute?.pageIndex > 1 &&
        this.pageDrugRoute?.content?.length === 1
      ) {
        this.searchDrugRoute.pageIndex -= 1;
      }
      this.pagingDrugRouteMethod();
      this.recentlyUpdated = true;
      this.handleClosePopup();

      toast.success("Xóa đường dùng của thuốc thành công!");
    } catch (error) {
      toast.error("Xóa đường dùng của thuốc thất bại!");
    }
  };

  handleDeleteDrugRoute = (drugRouteId) => {
    this.selectedDrugRoute = { id: drugRouteId ?? "" };
    this.openConfirmDeleteDrugRoute = true;
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteDrugRoute = false;
  };

  handleOpenSyncStore = () => {
    this.openSyncStore = true
  }

  handleCloseSyncStore = () => {
    this.openSyncStore = false
  }

  handleSaveSyncStore = (data, { setSubmitting }) => {
    saveDrugRouteSyncStore(data).then(() => {
      this.openSyncStore = false;
      toast.success("Đồng bộ thuốc thành công")
      this.pagingDrugRouteMethod()
    }).catch((err) => {
      toast.error("Đồng bộ thuốc thất bại")
    }).finally(() => {
      setSubmitting(false)
    })
  }

  resetStore = () => {
    this.searchDrugRoute = new SearchObject();
    this.pageDrugRoute = null;
    this.selectedDrugRoute = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteDrugRoute = false;
  };
}
